var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiles',[_c('card-widget',{staticClass:"tile is-child",attrs:{"type":"is-info","icon":"account-multiple","number":_vm.users.data.length,"label":"Count of Users"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }